module.exports = __webpack_public_path__ + "static/media/env2@2x.6c93bebc.png";